module.exports = __webpack_public_path__ + "static/media/Bhutan - BT.80bba994.png";